import { render } from "./UseGuide.vue?vue&type=template&id=f0f46dae"
import script from "./UseGuide.vue?vue&type=script&lang=js"
export * from "./UseGuide.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__